// Partials
import { Batches } from "./Partials/Batches";
import { Indicators } from "./Partials/Indicators";
import { Location } from "./Partials/Location";
import { PredominantBPArea } from "./Partials/PredominantBPArea";
import { PredominantLandArea } from "./Partials/PredominantLandArea";
import { Resume } from "./Partials/Resume";
import { Apresentation } from "./Partials/Apresentation";
import { Characteristcs } from "./Partials/Characteristcs";
import { Profile } from "./Partials/Profile";
import { VGV } from "./Partials/VGV";
import { Chart } from "./Partials/Chart";
import { IdealHouse } from "./Partials/IdealHouse";
import { IdealHouseCompare } from "./Partials/IdealHouseCompare";
import { IdealTerrain } from "./Partials/IdealTerrain";

// Types
import type { IIBatchesProps } from "./Partials/Batches/types";
import type { IIndicatorsProps } from "./Partials/Indicators/types";
import type { ILocationProps } from "./Partials/Location/types";
import type { IPredominantBPArea } from "./Partials/PredominantBPArea/types";
import type { IPredominantLandAreaProps } from "./Partials/PredominantLandArea/types";
import type { IResumeProps } from "./Partials/Resume/types";
import type { IApresentationProps } from "./Partials/Apresentation/types";
import type { ICharacteristcsProps } from "./Partials/Characteristcs/types";
import type { IProfileProps } from "./Partials/Profile/types";
import type { IVGVProps } from "./Partials/VGV/types";
import type { IChartProps } from "./Partials/Chart/types";
import type { IIdealHouseProps } from "./Partials/IdealHouse/types";
import type { IIdealHouseCompareProps } from "./Partials/IdealHouseCompare/types";
import type { IIdealTerrainProps } from "./Partials/IdealTerrain/types";

export const Steps = {
    IdealTerrain: (args: IIdealTerrainProps) => <IdealTerrain {...args}/>,
    IdealHouseCompare: (args: IIdealHouseCompareProps) => <IdealHouseCompare {...args}/>,
    IdealHouse: (args: IIdealHouseProps) => <IdealHouse {...args}/>,
    Chart: (args: IChartProps) => <Chart {...args}/>,
    VGV: (args: IVGVProps) => <VGV {...args}/>,
    Profile: (args: IProfileProps) => <Profile {...args}/>,
    Characteristcs: (args: ICharacteristcsProps) => <Characteristcs {...args}/>,
    Apresentation: (args: IApresentationProps) => <Apresentation {...args}/>,
    Location: (args: ILocationProps) => <Location {...args}/>,
    Indicators: (args: IIndicatorsProps) => <Indicators {...args}/>,
    Batches: (args: IIBatchesProps) => <Batches {...args}/>,
    Resume: (args: IResumeProps) => <Resume {...args}/>,
    PredominantBPArea: (args: IPredominantBPArea) => <PredominantBPArea {...args}/>,
    PredominantLandArea: (args: IPredominantLandAreaProps) => <PredominantLandArea {...args}/>
}
